import type { Locale } from '@ccex/shared';
import { catalogues, DEFAULT_LOCALE } from '@ccex/shared';
import { createI18n } from 'vue-i18n';

/** Both catalogues are small; they ship in the bundle and switch instantly. Dates go through
 * `useDateTime`, not `$d`, so the user's time zone applies everywhere. */
export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: catalogues,
});

export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
}
